module.exports = __webpack_public_path__ + "img/video-popup.a4b401c3.png";